import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Pager from 'ha/components/next/Pager';
import { Page } from 'ha/components/next/Pager/types';

import { changePage } from '../actions';
import { getPagerProps } from '../selectors';

const PagerContainer: React.FC = () => {
  const pagerProps = useSelector(getPagerProps);
  const dispatch = useDispatch();

  const onPageChange = React.useCallback(
    (payload: Page) => {
      dispatch(changePage(payload));

      window.scrollTo(0, 0);
    },
    [dispatch],
  );

  return <Pager {...pagerProps} onPageChange={onPageChange} />;
};

export default PagerContainer;
